export default __webpack_public_path__ + "6888fcd1f89db52bcdaf8e1eab494a1d.png";